/**
 * @sw-package b2b
 */
const PluginManager = window.PluginManager;

PluginManager.register('B2bBaseQuickOrder', () => import('./plugin/quick-order/base-quick-order.plugin'), '[data-b2b-base-quick-order]');
PluginManager.register('B2bQuickOrderList', () => import('./plugin/quick-order/listing.plugin'), '[data-b2b-quick-order-list]');
PluginManager.register('B2bQuickOrderItem', () => import('./plugin/quick-order/list-item.plugin'), '[data-b2b-quick-order-item]');
PluginManager.register('B2bQuickOrderUploadModal', () => import('./plugin/quick-order/file-upload-modal.plugin'), '[data-b2b-quick-order-upload-modal]');
PluginManager.register('B2bQuickOrderPagination', () => import('./plugin/quick-order/list-pagination.plugin'), '[data-b2b-quick-order-pagination]');
